import axios from 'axios';
import { TokenResponse } from '@react-oauth/google';

import { getStandardHeaders } from '@commons/utils/APICaller';

export const login = async (
  googleToken: Omit<TokenResponse, 'error' | 'error_description' | 'error_uri'>
): Promise<{ accessToken: string }> => {
  const headers = getStandardHeaders();

  const { data } = await axios.post(
    `${import.meta.env.VITE_API_URL}/login`,
    { googleToken: googleToken.access_token },
    {
      headers
    }
  );

  return data;
};
